"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const styled_components_1 = tslib_1.__importDefault(require("styled-components"));
const StyledFunctions_1 = require("../helpers/StyledFunctions");
const stringUtils_1 = require("../helpers/stringUtils");
const defaultProps = {};
const Image = (0, styled_components_1.default)('img') `
  width: ${props => (props.size ? `${props.size}` : '1rem')};
  height: ${props => (props.size ? `${props.size}` : '1rem')};
  border-radius: 50%;
  cursor: pointer;
  ${StyledFunctions_1.getMargin}
`;
const GRAVATAR_API_HOST = 'https://www.gravatar.com/avatar';
const Gravatar = ({ email, ...restProps }) => {
    const hash = (0, stringUtils_1.md5)(email);
    return react_1.default.createElement(Image, { src: `${GRAVATAR_API_HOST}/${hash}?s=200`, ...restProps });
};
Gravatar.defaultProps = defaultProps;
exports.default = Gravatar;
